import { Skeleton } from "@mui/material";
import { memo } from "react";
import { Box, ContentRepeater, FlexColBox } from "../../../components";
import { spacing, Styles } from "../../../../styles/theme";

const styles: Styles = {
  centerContainer: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    flex: "1",
    overflow: "auto",
    gap: { xs: spacing.regularMobile, lg: spacing.regularDesktop },
  },
  tableContainer: {
    width: "100%",
    maxHeight: "80vh",
    height: "100%",
  },
  tableHeader: {
    backgroundColor: "#F9F9FF",
    borderRadius: "8px 8px 0 0",
    padding: "16px",
    borderBottom: "1px solid #F4F4F4",
  },
  tableRow: {
    padding: "16px",
    borderBottom: "1px solid #F4F4F4",
    alignItems: "center",
  },
  tableColumn: {
    display: "flex",
    alignItems: "center",
  },
};

const TableSkeleton = () => {
  return (
    <Box sx={styles.centerContainer}>
      <FlexColBox sx={styles.tableContainer}>
        <Box
          sx={{ ...styles.tableHeader, display: "flex", flexDirection: "row" }}
        >
          <Box sx={{ ...styles.tableColumn, width: "5%" }}>
            <Skeleton width={20} height={20} variant="rounded" />
          </Box>
          <Box sx={{ ...styles.tableColumn, width: "22%" }}>
            <Skeleton width={120} height={16} variant="text" />
          </Box>
          <Box sx={{ ...styles.tableColumn, width: "23%" }}>
            <Skeleton width={100} height={16} variant="text" />
          </Box>
          <Box sx={{ ...styles.tableColumn, width: "18%" }}>
            <Skeleton width={90} height={16} variant="text" />
          </Box>
          <Box sx={{ ...styles.tableColumn, width: "22%" }}>
            <Skeleton width={140} height={16} variant="text" />
          </Box>
          <Box
            sx={{
              ...styles.tableColumn,
              width: "10%",
              justifyContent: "flex-end",
            }}
          >
            <Skeleton width={60} height={16} variant="text" />
          </Box>
        </Box>

        <FlexColBox>
          <ContentRepeater repeatCount={7}>
            <Box
              sx={{ ...styles.tableRow, display: "flex", flexDirection: "row" }}
            >
              <Box sx={{ ...styles.tableColumn, width: "5%" }}>
                <Skeleton width={24} height={24} variant="circular" />
              </Box>
              <Box sx={{ ...styles.tableColumn, width: "22%" }}>
                <Skeleton width={100} height={16} variant="text" />
              </Box>
              <Box sx={{ ...styles.tableColumn, width: "23%" }}>
                <Skeleton width={140} height={16} variant="text" />
              </Box>
              <Box sx={{ ...styles.tableColumn, width: "18%" }}>
                <Skeleton width={80} height={16} variant="text" />
              </Box>
              <Box sx={{ ...styles.tableColumn, width: "22%" }}>
                <FlexColBox gap="4px">
                  <Skeleton width={120} height={16} variant="text" />
                  <Skeleton width={160} height={12} variant="text" />
                </FlexColBox>
              </Box>
              <Box
                sx={{
                  ...styles.tableColumn,
                  width: "10%",
                  justifyContent: "flex-end",
                }}
              >
                <Skeleton width={24} height={24} variant="circular" />
              </Box>
            </Box>
          </ContentRepeater>
        </FlexColBox>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
            px: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton width={100} height={20} variant="text" />
            <Skeleton width={60} height={36} variant="rounded" />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton width={80} height={20} variant="text" />
            <Skeleton width={32} height={32} variant="circular" />
            <Skeleton width={32} height={32} variant="circular" />
            <Skeleton width={32} height={32} variant="circular" />
            <Skeleton width={32} height={32} variant="circular" />
          </Box>
        </Box>
      </FlexColBox>
    </Box>
  );
};

export default memo(TableSkeleton);
